import { atomWithStorage } from '@capsicum/common';

export const worldChampionshipDisclaimerAtom = atomWithStorage<boolean>('worldChampionshipDisclaimer', false);
